import DataPill from "@components/pills/DataPill";
import { KybLinkRecord } from "@services/models/Kyb/GetKybLinks";

/** Status is informational. Changes are explicit actions in the row menu. */
const SubmittedCellRenderer = ({ data }: { data: KybLinkRecord }) => (
  <DataPill
    value={data.is_submitted ? "submitted" : "pending"}
    tone={data.is_submitted ? "green" : "amber"}
  />
);

export default SubmittedCellRenderer;
